export const getHeaderRoutes = function(userType) {
	if(typeof userType === 'undefined') {
		return {
			mainRoutes: [],
			subRoutes: []
		}
	}
	const mainRoutes = getRoutesUserTypeContainer(userType, 'mainRoutes');
	const subRoutes = getRoutesUserTypeContainer(userType, 'subRoutes');
	return {
		mainRoutes,
		subRoutes
	}
}

export const getHomeRoutes = function() {
	const mainRoutes = getRoutesUserTypeContainer('Admin', 'mainRoutes');
	const subRoutes = getRoutesUserTypeContainer('Admin', 'subRoutes');
	const routes = mainRoutes.concat(subRoutes);
	return {
		routes
	}
}

const getUserRoutes = (userType) => {
	switch(userType) {
		case 'Admin':
			return {
				'mainRoutes': [
					'home',
					'leadtracker',
					'projectmanager',
					'logout'
				],
				'subRoutes': []
			}
		case 'Dispatch':
		default:
			return {
				'mainRoutes': [
					'home',
					'leadtracker',
					'projectmanager',
					'logout'
				],
				'subRoutes': []
			}
	}
}

const getRoutesUserTypeContainer = function(userType, containerName) {
	return getUserRoutes(userType)[containerName].map((name) => {
		return routes[name]
	});
}

const routes = {
	home: {
		title: 'Home',
		summary: 'Landing Page',
		routeName: 'home',
		icon: 'home'
	},
	'users': {
		'title': 'Users',
		'summary': 'Manage Users',
		'routeName': 'users',
		'icon': 'user'
	},
	leadtracker: {
		title: 'Lead Tracker',
		summary: 'Manage Leads',
		routeName: 'leadtracker',
		icon: 'form'
	},
	projectmanager: {
		title: 'Project Manager',
		summary: 'Manage Projects and Tasks',
		routeName: 'projectmanager',
		icon: 'dollar'
	},
	'logout': {
		'title': 'Logout',
		'summary': 'Log Out From Application',
		'routeName': '',
		'icon': 'log-out'
	}
}


// WEBPACK FOOTER //
// ./src/config/routeConfig.js